<template>
    <div class="video-player">
        <div
            ref="performPlayer"
            class="video perform-player"
        >
            <PerformPlayerScript
                v-if="containerWidth"
                :uuid="uuid"
                :streamId="streamId"
                :username="username"
                :containerWidth="containerWidth"
                :key="containerWidth"
            />
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    import PerformPlayerScript from './PerformPlayerScript';

    export default Vue.component('PerformPlayer', {
        props: {
            uuid: {
                type: String,
                required: true,
            },
            streamId: {
                type: String,
                required: true,
            },
            username: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                containerWidth: null,
            };
        },
        mounted() {
            window.addEventListener('resize', this.onResize);
            this.containerWidth = this.$refs.performPlayer.clientWidth;
        },
        methods: {
            onResize() {
                this.containerWidth = this.$refs.performPlayer.clientWidth;
            },
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },
        components: {
            PerformPlayerScript,
        },
    });
</script>
